import HtmlBlock from './HtmlBlock';
export type { HtmlBlockProps } from './HtmlBlock.d';

export default HtmlBlock;
